import React from 'react'

import styles  from './CustomProgressBar.module.scss';
import { ProgressBar } from 'react-bootstrap';

type CustomProgressBarType = {
  progressCount: number;
}

export default function CustomProgressBar({
  progressCount
}: CustomProgressBarType) {
  return (
    <>
      <ProgressBar
        className={styles.progress}
        now={progressCount}
      ></ProgressBar>
    </>
  );
}
